// extracted by mini-css-extract-plugin
export default {"modal":"VideoCarousel_modal__9BE0O","slide":"VideoCarousel_slide__Zjs5-","modalBtn":"VideoCarousel_modalBtn__oXvPS"};